const BADGE_TRACKING_EVENT = 'loyalty';

const BADGE_TRACKING_STEPS = {
    BADGES_SCREEN_VIEWED: 'Badges Screen Viewed',
    BADGES_IN_PROGRESS_CLICKED: 'Badges In Progress Clicked',
    BADGES_IN_PROGRESS_VIEWED: 'Badges in Progress Viewed',
    BADGE_CLICKED: 'Badge Clicked',
    BADGE_OVERVIEW: 'Badge Overview',
} as const;

const BADGE_TRACKING_INTERACTIONS = {
    SCREEN_VIEWED: 'Screen Viewed',
    BANNER_CLICKED: 'Banner Clicked',
    ICON_CLICKED: 'Icon Clicked',
} as const;

const BADGE_TRACKING_PAGE_IDS = {
    BADGES: 'Badges',
    BADGES_IN_PROGRESS: 'Badges in progress',
    BADGE_OVERVIEW: 'Badge Overview',
} as const;

const BADGE_TRACKING_VALUES = {
    BADGES_IN_PROGRESS: 'Badges in progress',
} as const;

const BADGE_TRACKING_VALUE_KEY = 'tracking_value';

export const BADGE_TRACKING = {
    EVENT: BADGE_TRACKING_EVENT,
    STEPS: BADGE_TRACKING_STEPS,
    INTERACTIONS: BADGE_TRACKING_INTERACTIONS,
    PAGE_IDS: BADGE_TRACKING_PAGE_IDS,
    TRACKING_VALUES: BADGE_TRACKING_VALUES,
    TRACKING_VALUE_KEY: BADGE_TRACKING_VALUE_KEY,
} as const;
